import { render, staticRenderFns } from "./LaboralDedicationList.vue?vue&type=template&id=04a1155a"
import script from "./LaboralDedicationList.vue?vue&type=script&lang=js"
export * from "./LaboralDedicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports